import { useMutation } from '@tanstack/react-query';
import { clearCachePromise, type ClearCacheSchema } from 'src/utils';
import { useNotification } from 'src/hooks/use-notification';

const ERROR_MESSAGE = 'Error clearing cache';

export const useClearCache = () => {
  const { mutateAsync, isPending } = useMutation({
    mutationFn: clearCachePromise,
  });
  const { enqueueErrorNotification, enqueueSuccessNotification } = useNotification();

  const clearCacheAsync = async (params: ClearCacheSchema) => {
    try {
      const res = await mutateAsync(params);

      if (!res) {
        enqueueErrorNotification(ERROR_MESSAGE);
      } else {
        enqueueSuccessNotification('Cache cleared');
        //resolve return
      }

      return res;
    } catch (error) {
      console.error(error);
      enqueueErrorNotification(ERROR_MESSAGE);
      return false;
    }
  };

  return {
    isLoading: isPending,
    clearCacheAsync,
  };
};
